<template>
  <content-wrapper>
    <content-header>
      My Profile
    </content-header>
    <Content>
      <b-row>
        <b-col md="3">
          <b-card no-body class="shadow rounded-4 overflow-hidden border-0 bg-light">
            <b-card-body class="box-profile p-4">
              <div class="text-center mb-4">
                <b-avatar
                  variant="primary"
                  size="5rem"
                  class="border border-white shadow-sm"
                  :text="getUserInitial"
                />
              </div>

              <h4 class="profile-username text-center fw-bold mb-1">
                {{ loggedInUser.username }}
              </h4>

              <div class="text-center text-muted mb-2 small">
                {{ loggedInUser.user_mail }}
              </div>

              <div class="d-flex justify-content-center mb-3">
                <span class="badge bg-secondary px-3 py-1">
                  {{ userLevelLabel }}
                </span>
              </div>

              
                <ul
                  class="list-group list-group-unbordered mb-0 rounded shadow-sm overflow-hidden"
                  v-if="loggedInUser.company"
                >
                  <li class="list-group-item px-2">
                    <div class="d-flex flex-column align-items-center">
                      <strong>Company</strong>
                      <div class="text-muted text-center">{{ loggedInUser.company.company_name }}</div>
                    </div>
                  </li>
                  <li class="list-group-item px-2">
                    <div class="d-flex flex-column align-items-center">
                      <strong>NIB</strong>
                      <div class="text-muted">{{ loggedInUser.company.NIB }}</div>
                    </div>
                  </li>
                  <li class="list-group-item px-2">
                    <div class="d-flex flex-column align-items-center">
                      <strong>NPWP</strong>
                      <div class="text-muted">{{ loggedInUser.company.NPWP }}</div>
                    </div>
                  </li>
                  <li class="list-group-item px-2">
                    <div class="d-flex flex-column align-items-center">
                      <strong>Member Since</strong>
                      <div class="text-muted text-center">{{ loggedInUser.company.member_since }}</div>
                    </div>
                  </li>
                </ul>
              
            </b-card-body>
          </b-card>
        </b-col>



        <b-col md="9"
        >
          <b-card no-body>
            <b-tabs pills card>
              <b-tab title="Password" active>
                <b-card-text>
                  <b-form-group
                      id="old_password_label"
                      label="Old Password"
                      label-for="old_password"
                  >
                    <b-form-input id="old_password"
                                  type="password"
                                  v-model="$v.formData.old_password.$model"
                                  trim
                                  :state="validateState('formData', 'old_password')"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This field is required and its min length is 8 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                      id="new_password_label"
                      label="New Password"
                      label-for="new_password"
                  >
                    <b-form-input id="new_password"
                                  type="password"
                                  v-model="$v.formData.password.$model"
                                  trim
                                  :state="validateState('formData', 'password')"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This field is required and its min length is 8 characters
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-form-group
                      id="retype_password_label"
                      label="Retype Password"
                      label-for="retype_password"
                  >
                    <b-form-input id="retype_password"
                                  type="password"
                                  v-model="$v.formData.retype_password.$model"
                                  trim
                                  :state="validateState('formData', 'retype_password')"
                    ></b-form-input>
                    <b-form-invalid-feedback>
                      This field is required, its min length is 8 characters and it must be identical with New Password
                    </b-form-invalid-feedback>
                  </b-form-group>
                  <b-button variant="primary" @click="submitPassword">
                    Update!
                    <b-spinner v-if="isSubmitting" small></b-spinner>
                  </b-button>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </Content>
  </content-wrapper>
</template>

<script>
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {BTab, BTabs, } from "bootstrap-vue";
import {validationMixin} from "vuelidate";
import {formValidation} from "@/mixins/formValidation";
import {required, sameAs, minLength, not} from "vuelidate/lib/validators";
import {setPassword} from "@/services/users";
import {hasOwnProperty} from "@/helpers/Utils";
export default {
  name: "Profile",
  mixins: [
    userInfoMixin, validationMixin, formValidation,
  ],
  components: {
    BTab, BTabs,
  },
  validations: {
    formData: {
      old_password: {
        required,
        minLength: minLength(8),
      },
      password: {
        required,
        minLength: minLength(8),
        different: not(sameAs('old_password'))
      },
      retype_password: {
        required,
        minLength: minLength(8),
        sameAsPassword: sameAs('password'),
      },
    }
  },
  data: ()=>({
    isSubmitting: false,
    formData: {
      old_password:'',
      password: '',
      retype_password: '',
    },
  }),
  methods: {
    async submitPassword() {
      this.isSubmitting = true;
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        this.$bvToast.toast(`Missing required information!`, {
          title: 'Error!',
          autoHideDelay: 1500,
          variant: 'danger',
        })
        return;
      }
      try {
        await setPassword({
          username: this.loggedInUser.username,
          'old-password': this.formData.old_password,
          'new-password': this.formData.password,
          'cfm-password': this.formData.retype_password,
        });
        this.$bvToast.toast(`Password updated!!`, {
          title: 'Congratulations!',
          autoHideDelay: 1500,
          variant: 'success',
        })
        this.isSubmitting = false;
      } catch (e) {
        this.isSubmitting = false;
        if (!hasOwnProperty(e, 'response')) {
          this.$bvToast.toast(`${e.message}`, {
            title: 'Error!',
            autoHideDelay: 1500,
            variant: 'danger',
          })
          return;
        }
      }
    },
  },
  computed: {
    getUserInitial() {
      const username = this.loggedInUser?.username || '';
      return username.charAt(0).toUpperCase() || '?';
    },
    userLevelLabel() {
      switch (this.loggedInUser?.level) {
        case 1: return 'Super Admin';
        case 2: return 'Admin';
        case 3: return 'Normal User';
        case 4: return 'Control Room';
        case 5: return 'Gate Pass';
        default: return this.loggedInUser?.level || '-';
      }
    }
  }
}
</script>

<style scoped>
  .box-profile {
    background: linear-gradient(to bottom right, #f8f9fa, #e9ecef);
    border-radius: 1rem;
  }

  .profile-username {
    font-size: 1.25rem;
  }
</style>
